// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ESTILOS PARA EL MÓDULO ECOMMERCE
   ========================================================================== */

:root {
  --ecom-primary: #0d6efd;
  --ecom-primary-dark: #0a58ca;
  --ecom-primary-light: #e7f1ff;
  --ecom-primary-light-bg: #f8fafc;
  --ecom-primary-text: #ffffff;
  --ecom-button: #ffc107;
  --ecom-button-dark: #e0a800;
  --ecom-button-text: #111827;
  --ecom-accent: #ff6b35;
  --ecom-accent-dark: #e85924;
  --ecom-accent-light: #fff3ed;
  --ecom-navbar-bg: #ffffff;
  --ecom-navbar-text: #1e293b;
  --ecom-dark: #1e293b;
  --ecom-text: #334155;
  --ecom-muted: #64748b;
  --ecom-bg: #f8fafc;
  --ecom-card-bg: #ffffff;
  --ecom-sidebar-bg: #ffffff;
  --ecom-sidebar-title: #1e293b;
  --ecom-footer-bg: #ffffff;
  --ecom-footer-text: #64748b;
  --ecom-footer-title: #1e293b;
  --ecom-border: #e2e8f0;
  --ecom-radius: 12px;
  --ecom-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03);
  --ecom-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.04);
  --ecom-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.03);
  --ecom-transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

html,
body {
  max-width: 100%;
  overflow-x: clip;
}

.ecommerce-container,
.webstore-site-wrapper,
.landing-site-wrapper,
.site-page-container {
  background-color: var(--ecom-bg, #f8fafc);
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  overflow-x: clip;
  color: var(--ecom-text, #1e293b);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  position: relative;
}

.unified-header-wrapper {
  position: sticky;
  top: 0;
  z-index: 1040 !important;
}

.dropdown-toggle-no-caret::after {
  display: none !important;
}

/* ==========================================================================
   SOBREESCRITURAS DE TEMA PERSONALIZADO (APLICACIÓN GLOBAL EN TODA LA WEB)
   ========================================================================== */

/* 1. Botones Primarios (Acción Principal, Filtros Activos, Confirmaciones) */
.ecommerce-container .btn-primary,
.webstore-site-wrapper .btn-primary,
.landing-site-wrapper .btn-primary,
.site-page-container .btn-primary,
.btn-theme-primary,
.btn-primary:not(.admin-btn):not(.btn-close) {
  background-color: var(--ecom-primary, #0d6efd) !important;
  border-color: var(--ecom-primary, #0d6efd) !important;
  color: var(--ecom-primary-text, #ffffff) !important;
  border-radius: var(--ecom-radius, 12px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.ecommerce-container .btn-primary:hover,
.webstore-site-wrapper .btn-primary:hover,
.landing-site-wrapper .btn-primary:hover,
.site-page-container .btn-primary:hover,
.btn-theme-primary:hover,
.btn-primary:not(.admin-btn):not(.btn-close):hover {
  background-color: var(--ecom-primary-dark, #0a58ca) !important;
  border-color: var(--ecom-primary-dark, #0a58ca) !important;
  color: var(--ecom-primary-text, #ffffff) !important;
  filter: brightness(0.94);
}

/* 2. Botones de Compra, Carrito y Destacados (Color de Botón Configurado) */
.ecommerce-container .btn-warning,
.webstore-site-wrapper .btn-warning,
.landing-site-wrapper .btn-warning,
.site-page-container .btn-warning,
.btn-theme-button,
.ecom-cart-btn,
.ecom-btn-buy,
.ecom-btn-action {
  background-color: var(--ecom-button, #ffc107) !important;
  border-color: var(--ecom-button, #ffc107) !important;
  color: var(--ecom-button-text, #111827) !important;
  border-radius: var(--ecom-radius, 12px);
  font-weight: 700;
}

.ecommerce-container .btn-warning:hover,
.webstore-site-wrapper .btn-warning:hover,
.landing-site-wrapper .btn-warning:hover,
.site-page-container .btn-warning:hover,
.btn-theme-button:hover,
.ecom-cart-btn:hover,
.ecom-btn-buy:hover {
  background-color: var(--ecom-button-dark, #e0a800) !important;
  border-color: var(--ecom-button-dark, #e0a800) !important;
  color: var(--ecom-button-text, #111827) !important;
  filter: brightness(0.93);
}

/* 3. Botones Outline Primarios */
.ecommerce-container .btn-outline-primary,
.webstore-site-wrapper .btn-outline-primary,
.landing-site-wrapper .btn-outline-primary,
.site-page-container .btn-outline-primary {
  color: var(--ecom-primary, #0d6efd) !important;
  border-color: var(--ecom-primary, #0d6efd) !important;
  border-radius: var(--ecom-radius, 12px);
  background-color: transparent !important;
}

.ecommerce-container .btn-outline-primary:hover,
.webstore-site-wrapper .btn-outline-primary:hover,
.landing-site-wrapper .btn-outline-primary:hover,
.site-page-container .btn-outline-primary:hover {
  background-color: var(--ecom-primary, #0d6efd) !important;
  border-color: var(--ecom-primary, #0d6efd) !important;
  color: var(--ecom-primary-text, #ffffff) !important;
}

/* 4. Textos, Enlaces e Íconos con Color Primario */
.ecommerce-container .text-primary,
.webstore-site-wrapper .text-primary,
.landing-site-wrapper .text-primary,
.site-page-container .text-primary,
.text-theme-primary {
  color: var(--ecom-primary, #0d6efd) !important;
}

.ecommerce-container a.text-primary:hover,
.webstore-site-wrapper a.text-primary:hover,
.landing-site-wrapper a.text-primary:hover,
.site-page-container a.text-primary:hover {
  color: var(--ecom-primary-dark, #0a58ca) !important;
}

/* 5. Fondos y Badges Primarios / Sutiles */
.ecommerce-container .bg-primary,
.webstore-site-wrapper .bg-primary,
.landing-site-wrapper .bg-primary,
.site-page-container .bg-primary,
.bg-theme-primary {
  background-color: var(--ecom-primary, #0d6efd) !important;
  color: var(--ecom-primary-text, #ffffff) !important;
}

.ecommerce-container .bg-primary-subtle,
.webstore-site-wrapper .bg-primary-subtle,
.landing-site-wrapper .bg-primary-subtle,
.site-page-container .bg-primary-subtle,
.bg-theme-primary-subtle {
  background-color: var(--ecom-primary-light, #e7f1ff) !important;
  color: var(--ecom-primary, #0d6efd) !important;
}

/* 6. Badges de Acento y Ofertas */
.ecommerce-container .ecom-cart-badge,
.webstore-site-wrapper .ecom-cart-badge,
.landing-site-wrapper .ecom-cart-badge,
.badge-accent,
.bg-accent {
  background-color: var(--ecom-accent, #ff6b35) !important;
  color: #ffffff !important;
}

/* 7. Barra de Navegación */
.ecommerce-container .ecom-navbar,
.webstore-site-wrapper .ecom-navbar,
.landing-site-wrapper .ecom-navbar {
  background-color: var(--ecom-navbar-bg, #ffffff) !important;
}

/* 8. Fondo de Barra Lateral / Filtros / Cards */
.ecommerce-container .ecom-sidebar-card,
.webstore-site-wrapper .ecom-sidebar-card,
.landing-site-wrapper .ecom-sidebar-card,
.card-theme {
  background-color: var(--ecom-sidebar-bg, #ffffff) !important;
}

.ecommerce-container .ecom-sidebar-card h6,
.webstore-site-wrapper .ecom-sidebar-card h6,
.landing-site-wrapper .ecom-sidebar-card h6,
.ecom-sidebar-card .text-dark {
  color: var(--ecom-sidebar-title, #1e293b) !important;
}

/* 9. Pie de Página / Footer */
.ecommerce-container .ecom-footer,
.webstore-site-wrapper .ecom-footer,
.landing-site-wrapper .ecom-footer,
.ecom-footer {
  background-color: var(--ecom-footer-bg, #ffffff) !important;
  color: var(--ecom-footer-text, #64748b) !important;
  border-color: var(--ecom-footer-border, #e2e8f0) !important;
}

.ecommerce-container .ecom-footer h6,
.webstore-site-wrapper .ecom-footer h6,
.landing-site-wrapper .ecom-footer h6,
.ecom-footer h6,
.ecom-footer .text-dark,
.ecom-footer strong,
.ecom-footer .fw-extrabold,
.ecom-footer .fw-bold {
  color: var(--ecom-footer-title, #1e293b) !important;
}

.ecommerce-container .ecom-footer p,
.webstore-site-wrapper .ecom-footer p,
.landing-site-wrapper .ecom-footer p,
.ecom-footer p,
.ecom-footer .text-muted,
.ecom-footer .text-secondary,
.ecom-footer span:not(.badge):not(.fs-5),
.ecom-footer li {
  color: var(--ecom-footer-text, #64748b) !important;
}

/* --- Demo Top Bar --- */
.ecom-demo-bar {
  background: linear-gradient(90deg, #1e293b 0%, #334155 100%);
  color: #f1f5f9;
  font-size: 0.85rem;
  padding: 8px 16px;
  border-bottom: 1px solid #475569;
  z-index: 1040;
}

.ecom-demo-badge {
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* --- Navbar --- */
.ecom-navbar {
  background-color: #ffffff;
  border-bottom: 1px solid var(--ecom-border);
  box-shadow: var(--ecom-shadow-sm);
  position: sticky;
  top: 0;
  z-index: 1030;
  padding: 12px 0;
}

.ecom-brand {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: var(--ecom-dark);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ecom-brand .brand-badge {
  font-size: 0.7rem;
  background-color: var(--ecom-primary);
  color: white;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 600;
  text-transform: uppercase;
}

.ecom-search-input {
  border-radius: 30px;
  padding-left: 42px;
  padding-right: 18px;
  background-color: #f1f5f9;
  border: 1px solid transparent;
  transition: var(--ecom-transition);
  font-size: 0.95rem;
}

.ecom-search-input:focus {
  background-color: #ffffff;
  border-color: var(--ecom-primary);
  box-shadow: 0 0 0 4px var(--ecom-primary-light);
}

.ecom-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--ecom-muted);
  pointer-events: none;
  font-size: 1.1rem;
}

/* --- Navbar Action Buttons Unified Height & Styling --- */
.ecom-navbar .btn-sm {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.86rem;
  line-height: 1;
  box-sizing: border-box;
}

@media (max-width: 576px) {
  .ecom-navbar .btn-sm {
    height: 34px;
    font-size: 0.82rem;
  }
}

.ecom-cart-btn {
  position: relative;
  border-radius: 30px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
  transition: var(--ecom-transition);
  flex-shrink: 0;
}

.ecom-cart-btn i {
  font-size: 1.1rem;
  line-height: 1;
  display: flex;
  align-items: center;
}

@media (max-width: 576px) {
  .ecom-cart-btn {
    padding: 0 11px;
  }
  .ecom-cart-btn i {
    font-size: 1rem;
  }
}

.ecom-cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: var(--ecom-accent);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.15);
  animation: scaleIn 0.3s ease-out;
}

@keyframes scaleIn {
  0% { transform: scale(0); }
  80% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

/* --- User Profile Pill (Navbar) --- */
.ecom-user-pill {
  height: 38px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: var(--ecom-transition);
  cursor: pointer;
  color: #1e293b;
  box-sizing: border-box;
}

@media (max-width: 576px) {
  .ecom-user-pill {
    height: 34px;
    padding: 0 10px;
  }
}

.ecom-user-pill:hover,
.ecom-user-pill:focus,
.ecom-user-pill[aria-expanded="true"] {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.ecom-user-pill .user-name {
  color: #1e293b !important;
  font-weight: 600;
  font-size: 0.83rem;
  max-width: 145px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.ecom-user-pill .user-list {
  color: var(--ecom-primary) !important;
  font-weight: 700;
  font-size: 0.7rem;
  display: block;
}

.ecom-user-pill::after {
  display: none !important;
}


/* --- Carrusel Superior: 100% SOLO IMÁGENES --- */
.ecom-pure-carousel-wrapper {
  border-radius: 16px;
  background-color: #0b192c;
  overflow: hidden;
}

.ecom-pure-carousel {
  border-radius: 16px;
}

.ecom-pure-carousel-item {
  width: 100%;
  aspect-ratio: 1200 / 320;
  min-height: 180px;
  max-height: 320px;
  background-color: #0b192c;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ecom-pure-carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.ecom-pure-carousel-item:hover .ecom-pure-carousel-img {
  transform: scale(1.015);
}

.ecom-pure-carousel .carousel-indicators {
  margin-bottom: 12px;
}

.ecom-pure-carousel .carousel-indicators [data-bs-target] {
  width: 26px;
  height: 6px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.45);
  border: none;
  transition: all 0.3s ease;
  margin: 0 3px;
}

.ecom-pure-carousel .carousel-indicators .active {
  background-color: #ffc107;
  width: 44px;
}

.ecom-pure-carousel .carousel-control-prev,
.ecom-pure-carousel .carousel-control-next {
  width: 48px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ecom-pure-carousel:hover .carousel-control-prev,
.ecom-pure-carousel:hover .carousel-control-next {
  opacity: 0.9;
}

.ecom-pure-carousel .carousel-control-prev-icon,
.ecom-pure-carousel .carousel-control-next-icon {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 16px;
  border-radius: 50%;
  backdrop-filter: blur(4px);
}


/* --- Hero Banner Fijo Original --- */
.ecom-hero-banner {
  background: linear-gradient(135deg, var(--ecom-primary, #0d6efd) 0%, var(--ecom-primary-dark, #0a58ca) 100%) !important;
  color: white;
  border-radius: var(--ecom-radius);
  padding: 36px 32px;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  box-shadow: var(--ecom-shadow-md);
}

.ecom-hero-banner::after {
  content: "";
  position: absolute;
  right: -40px;
  top: -40px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%);
  border-radius: 50%;
}





/* --- Product Cards --- */
.ecom-product-card {
  background: var(--ecom-card-bg);
  border: 1px solid var(--ecom-border);
  border-radius: var(--ecom-radius);
  transition: var(--ecom-transition);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-shadow: var(--ecom-shadow-sm);
}

.ecom-product-card.ecom-product-on-sale {
  border-color: rgba(220, 53, 69, 0.25);
}

.ecom-product-card.ecom-product-on-sale:hover {
  border-color: rgba(220, 53, 69, 0.55);
  box-shadow: 0 10px 25px -5px rgba(220, 53, 69, 0.12), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
}

.ecom-product-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--ecom-shadow-lg);
  border-color: #cbd5e1;
}

.ecom-card-img-container {
  height: 200px;
  background-color: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid var(--ecom-border);
  padding: 16px;
}

.ecom-card-img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.ecom-product-card:hover .ecom-card-img {
  transform: scale(1.05);
}

/* --- Vista de Lista Horizontal (ecom-product-card-list) --- */
.ecom-product-card-list {
  display: block;
  height: auto;
  min-height: auto;
}

.ecom-product-card-list:hover {
  transform: translateY(-2px);
  box-shadow: var(--ecom-shadow-md);
}

.ecom-card-list-img-container {
  width: 140px;
  height: 130px;
  background-color: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: calc(var(--ecom-radius) - 4px);
  border: 1px solid var(--ecom-border);
  overflow: hidden;
  padding: 8px;
}

.ecom-card-list-img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.ecom-product-card-list:hover .ecom-card-list-img {
  transform: scale(1.06);
}

.ecom-card-list-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ecom-card-list-actions {
  min-width: 230px;
}

@media (max-width: 767.98px) {
  .ecom-card-list-img-container {
    width: 100%;
    height: 180px;
  }
  .ecom-card-list-actions {
    min-width: 100%;
  }
}

.ecom-card-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
}

.ecom-card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.ecom-card-brand {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--ecom-muted);
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.ecom-card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ecom-dark);
  line-height: 1.35;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.7em;
  cursor: pointer;
}

.ecom-card-title:hover {
  color: var(--ecom-primary);
}

.ecom-card-code {
  font-size: 0.75rem;
  color: var(--ecom-muted);
  font-family: monospace;
  margin-bottom: 10px;
}

/* --- Varieties / Colors Selector --- */
.ecom-variants-container {
  margin-bottom: 12px;
}

.ecom-variant-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ecom-muted);
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
}

.ecom-variant-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ecom-variant-pill {
  font-size: 0.75rem;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid var(--ecom-border);
  background-color: #f8fafc;
  color: var(--ecom-text);
  cursor: pointer;
  transition: var(--ecom-transition);
}

.ecom-variant-pill:hover {
  border-color: var(--ecom-primary);
}

.ecom-variant-pill.selected {
  background-color: var(--ecom-primary-light);
  border-color: var(--ecom-primary);
  color: var(--ecom-primary-dark);
  font-weight: 600;
}

.ecom-color-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #cbd5e1;
  cursor: pointer;
  transition: transform 0.15s ease;
  display: inline-block;
}

.ecom-color-dot.selected {
  transform: scale(1.2);
  box-shadow: 0 0 0 2px var(--ecom-primary);
}

/* --- Price Display Area --- */
.ecom-price-container {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px dashed var(--ecom-border);
  margin-bottom: 12px;
}

.ecom-price-value {
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--ecom-dark);
}

.ecom-price-locked {
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.8rem;
  color: var(--ecom-muted);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  transition: var(--ecom-transition);
}

.ecom-price-locked:hover {
  background-color: var(--ecom-primary-light);
  border-color: var(--ecom-primary);
  color: var(--ecom-primary-dark);
}

/* --- Quantity Controls --- */
.ecom-qty-picker {
  display: inline-flex;
  align-items: stretch;
  flex-shrink: 0;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  height: 36px;
  box-sizing: border-box;
}

.ecom-qty-picker-lg {
  height: 44px;
}

.ecom-qty-btn {
  background: #f8fafc;
  border: none;
  width: 36px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ecom-dark);
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
  border-radius: 0;
  box-sizing: border-box;
  outline: none;
}

.ecom-qty-picker-lg .ecom-qty-btn {
  width: 44px;
}

.ecom-qty-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.ecom-qty-btn:active {
  background: #cbd5e1;
}

.ecom-qty-input {
  width: 44px;
  height: 100%;
  border: none;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  text-align: center;
  font-weight: 600;
  font-size: 0.92rem;
  color: var(--ecom-dark);
  background: #ffffff;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.ecom-qty-picker-lg .ecom-qty-input {
  width: 52px;
  font-size: 1.05rem;
}

.ecom-qty-input:focus {
  outline: none;
  background: #ffffff;
}

/* --- Product Card Quantity Picker & Action Button --- */
.ecom-product-card .ecom-qty-picker {
  flex-shrink: 0;
  height: 34px;
}

.ecom-product-card .ecom-qty-btn {
  width: 28px;
  font-size: 0.82rem;
}

.ecom-product-card .ecom-qty-input {
  width: 32px;
  font-size: 0.84rem;
}

.ecom-card-action-btn {
  height: 34px;
  padding: 0 10px;
  font-size: 0.8rem;
  white-space: nowrap;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 140px;
  box-sizing: border-box;
}

.ecom-card-action-btn span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecom-card-action-btn i {
  font-size: 0.82rem;
  flex-shrink: 0;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ecom-product-card .ecom-qty-picker {
    height: 32px;
  }
  .ecom-product-card .ecom-qty-btn {
    width: 25px;
  }
  .ecom-product-card .ecom-qty-input {
    width: 28px;
    font-size: 0.8rem;
  }
  .ecom-card-action-btn {
    height: 32px;
    padding: 0 5px;
    font-size: 0.73rem;
    gap: 2px;
  }
  .ecom-card-action-btn i {
    font-size: 0.74rem;
  }
}

/* --- Custom Modal & Drawer Close Buttons --- */
.ecom-modal-close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 30;
  transition: all 0.2s ease;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  font-size: 1rem;
  flex-shrink: 0;
  box-sizing: border-box;
}

.ecom-modal-close-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
  border-color: #cbd5e1;
  transform: scale(1.08);
}

/* --- Detalle de Producto: Zoom interactivo (Lupa) y Lightbox --- */
.ecom-detail-img-wrapper {
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  background-color: #f8fafc;
}

.ecom-detail-img-wrapper:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.ecom-lightbox-modal .modal-content {
  background: rgba(15, 23, 42, 0.96) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ecom-lightbox-modal .modal-dialog {
  margin: 0;
  max-width: 100vw;
  height: 100vh;
}


.ecom-drawer-close-btn {
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  max-width: 34px;
  max-height: 34px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  transition: all 0.15s ease;
  font-size: 0.95rem;
  box-sizing: border-box;
}

.ecom-drawer-close-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
  border-color: #cbd5e1;
}

/* --- Cart Drawer (Offcanvas) --- */
.ecom-cart-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 440px;
  height: 100vh;
  background: #ffffff;
  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);
  z-index: 1060;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.ecom-cart-drawer.open {
  transform: translateX(0);
}

.ecom-cart-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1050;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.ecom-cart-backdrop.open {
  opacity: 1;
  pointer-events: auto;
}

.ecom-cart-header {
  padding: 18px 24px;
  border-bottom: 1px solid var(--ecom-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.ecom-cart-body {
  padding: 16px 24px;
  overflow-y: auto;
  flex-grow: 1;
}

.ecom-cart-item {
  display: flex;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid var(--ecom-border);
}

.ecom-cart-item:last-child {
  border-bottom: none;
}

.ecom-cart-item-img {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: #f8fafc;
  object-fit: contain;
  padding: 6px;
  border: 1px solid var(--ecom-border);
  flex-shrink: 0;
}

.ecom-cart-item-details {
  flex-grow: 1;
  min-width: 0;
}

.ecom-cart-item-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ecom-dark);
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecom-cart-item-variant {
  font-size: 0.75rem;
  color: var(--ecom-muted);
  margin-bottom: 6px;
}

.ecom-cart-item-price {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ecom-dark);
}

.ecom-cart-footer {
  padding: 20px 24px;
  border-top: 1px solid var(--ecom-border);
  background: #f8fafc;
}

/* --- Footer --- */
.ecom-footer {
  margin-top: auto;
  background-color: var(--ecom-footer-bg, #ffffff);
  border-top: 1px solid var(--ecom-border);
  padding: 32px 0 20px;
  color: var(--ecom-footer-text, #64748b);
  font-size: 0.85rem;
}

/* --- Responsive Adjustments --- */
@media (max-width: 768px) {
  .ecom-hero-banner {
    padding: 24px 20px;
  }
  .ecom-cart-drawer {
    max-width: 100%;
  }
}

/* --- Filter Lists (Sidebar) --- */
.ecom-filter-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.ecom-filter-list::-webkit-scrollbar {
  width: 5px;
}

.ecom-filter-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.ecom-filter-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.ecom-filter-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.ecom-filter-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 34px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: #475569;
  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.3;
  text-align: left;
  flex-shrink: 0;
  transition: all 0.15s ease;
  cursor: pointer;
  text-decoration: none;
}

.ecom-filter-item:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.ecom-filter-item.active {
  background-color: #e0edff;
  color: #0d6efd;
  font-weight: 700;
  border-color: #bfdbfe;
}

.ecom-filter-item .item-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

/* --- Presentation Filter Pills --- */
.ecom-presentation-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  background: #f1f5f9;
  padding: 3px;
  border-radius: 10px;
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
}

.ecom-presentation-btn {
  width: 100%;
  min-width: 0;
  padding: 6px 3px;
  font-size: 0.74rem;
  font-weight: 600;
  border: none;
  background: transparent;
  color: #64748b;
  border-radius: 8px;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  box-sizing: border-box;
}

.ecom-presentation-btn i {
  font-size: 0.72rem;
  flex-shrink: 0;
  line-height: 1;
}

.ecom-presentation-btn span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecom-presentation-btn.active {
  background: #ffffff;
  color: #0d6efd;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

@media (min-width: 992px) and (max-width: 1199px) {
  .ecom-presentation-btn {
    padding: 5px 2px;
    font-size: 0.71rem;
    gap: 2px;
  }
  .ecom-presentation-btn i {
    font-size: 0.68rem;
  }
}

/* --- Color Filter Swatches --- */
.ecom-color-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ecom-color-swatch-item {
  width: 26px;
  height: 26px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #cbd5e1;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
}

.ecom-color-swatch-item:hover {
  transform: scale(1.15);
  box-shadow: 0 0 0 2px #94a3b8;
}

.ecom-color-swatch-item.selected {
  transform: scale(1.2);
  box-shadow: 0 0 0 2px #0d6efd;
}

.ecom-color-swatch-rainbow {
  background: linear-gradient(135deg, #ef4444, #eab308, #10b981, #3b82f6, #8b5cf6) !important;
}

.ecom-color-swatch-trans {
  background: repeating-linear-gradient(45deg, #f8fafc, #f8fafc 4px, #cbd5e1 4px, #cbd5e1 8px) !important;
}

/* --- Variant Selector on Product Card --- */
.ecom-variants-container {
  margin-bottom: 12px;
}

.ecom-variant-label {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 6px;
}

.ecom-variant-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.ecom-color-dot {
  width: 18px;
  height: 18px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #cbd5e1;
  transition: all 0.15s ease;
  flex-shrink: 0;
  box-sizing: border-box;
}

.ecom-color-dot:hover {
  transform: scale(1.18);
}

.ecom-color-dot.selected {
  transform: scale(1.28);
  box-shadow: 0 0 0 2px #0d6efd;
}

.ecom-variant-pill {
  font-size: 0.72rem;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ecom-variant-pill:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* --- Detail Modal Variant Selector --- */
.ecom-detail-color-swatch {
  width: 34px;
  height: 34px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  border: 2px solid transparent;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.ecom-detail-color-swatch:hover {
  border-color: #cbd5e1;
  transform: scale(1.06);
}

.ecom-detail-color-swatch.selected {
  border-color: var(--ecom-primary, #0d6efd);
  box-shadow: 0 0 0 1px var(--ecom-primary, #0d6efd);
}

.ecom-detail-color-swatch-dot {
  width: 22px;
  height: 22px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  box-sizing: border-box;
}

.ecom-variant-pill.selected {
  background: #e0edff;
  border-color: #93c5fd;
  color: #0d6efd;
  font-weight: 600;
}

/* --- Mobile Filter Drawer (Slide-over) --- */
.ecom-filter-drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 360px;
  height: 100vh;
  background: #ffffff;
  box-shadow: 4px 0 25px rgba(0, 0, 0, 0.15);
  z-index: 1060;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.ecom-filter-drawer.open {
  transform: translateX(0);
}

.ecom-filter-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1050;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.ecom-filter-backdrop.open {
  opacity: 1;
  pointer-events: auto;
}

.ecom-filter-drawer-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--ecom-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}

.ecom-filter-drawer-body {
  padding: 16px 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.ecom-filter-drawer-body .ecom-sidebar-card {
  box-shadow: none !important;
  border: none !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
}

.ecom-filter-drawer-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--ecom-border);
  background: #ffffff;
}

/* --- Discreet Collapse Button for Desktop Sidebar --- */
.ecom-collapse-trigger-btn {
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.ecom-collapse-trigger-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
  border-color: #cbd5e1;
  transform: scale(1.1);
}

/* --- Floating WhatsApp Shortcut Button --- */
.ecom-whatsapp-float-wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1025;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: slideUpFade 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  max-width: calc(100vw - 32px);
}

@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.ecom-whatsapp-btn {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(37, 211, 102, 0.45), 0 2px 6px rgba(0, 0, 0, 0.15);
  text-decoration: none;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  flex-shrink: 0;
}

.ecom-whatsapp-btn:hover {
  color: #ffffff;
  transform: scale(1.08) rotate(3deg);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6), 0 4px 10px rgba(0, 0, 0, 0.2);
}

.ecom-whatsapp-btn:active {
  transform: scale(0.95);
}

.ecom-whatsapp-btn i {
  font-size: 1.95rem;
  line-height: 1;
}

/* Tooltip / Pill text */
.ecom-whatsapp-pill {
  background: #ffffff;
  color: #1e293b;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  max-width: calc(100vw - 120px);
  overflow: hidden;
  text-overflow: ellipsis;
}

.ecom-whatsapp-pill:hover {
  background: #f8fafc;
  border-color: #25D366;
}

/* Close 'X' button */
.ecom-whatsapp-close {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #334155;
  color: #ffffff;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.ecom-whatsapp-close:hover {
  background: #ef4444;
  transform: scale(1.15);
}

/* Pulse animation */
.ecom-whatsapp-pulse {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #25D366;
  opacity: 0.6;
  animation: waPulse 2.2s infinite;
  z-index: -1;
}

@keyframes waPulse {
  0% {
    transform: scale(0.95);
    opacity: 0.7;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

/* --- Floating Scroll to Top Button --- */
.ecom-scroll-top-wrapper {
  position: fixed;
  bottom: 92px;
  right: 31px;
  z-index: 1024;
  opacity: 0;
  visibility: hidden;
  transform: translateY(14px) scale(0.9);
  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1),
              visibility 0.3s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
              bottom 0.35s cubic-bezier(0.16, 1, 0.3, 1),
              right 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: none;
}

.ecom-scroll-top-wrapper.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

/* Reposicionamiento fluido cuando WhatsApp se encuentra cerrado */
.ecom-scroll-top-wrapper.no-whatsapp {
  bottom: 24px;
  right: 24px;
}

.ecom-scroll-top-btn {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #0f172a;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.28), 0 2px 6px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  padding: 0;
}

.ecom-scroll-top-btn i {
  font-size: 1.25rem;
  line-height: 1;
  font-weight: 700;
  transition: transform 0.2s ease;
}

/* Tooltip on hover */
.ecom-scroll-top-tooltip {
  position: absolute;
  right: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%) translateX(6px);
  background: #0f172a;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 5px 11px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.ecom-scroll-top-tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  right: -4px;
  transform: translateY(-50%);
  border-width: 4px 0 4px 4px;
  border-style: solid;
  border-color: transparent transparent transparent #0f172a;
}

.ecom-scroll-top-btn:hover {
  background: #0d6efd;
  color: #ffffff;
  border-color: #0d6efd;
  transform: translateY(-3px) scale(1.06);
  box-shadow: 0 8px 22px rgba(13, 110, 253, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15);
}

.ecom-scroll-top-btn:hover i {
  transform: translateY(-2px);
}

.ecom-scroll-top-btn:hover .ecom-scroll-top-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0);
}

.ecom-scroll-top-btn:active {
  transform: translateY(0) scale(0.95);
}

@media (max-width: 576px) {
  .ecom-whatsapp-float-wrapper {
    bottom: 18px;
    right: 18px;
  }
  .ecom-whatsapp-btn {
    width: 52px;
    height: 52px;
  }
  .ecom-whatsapp-btn i {
    font-size: 1.7rem;
  }
  .ecom-scroll-top-wrapper {
    bottom: 78px;
    right: 24px;
  }
  .ecom-scroll-top-wrapper.no-whatsapp {
    bottom: 18px;
    right: 18px;
  }
  .ecom-scroll-top-btn {
    width: 42px;
    height: 42px;
  }
  .ecom-scroll-top-btn i {
    font-size: 1.15rem;
  }
  .ecom-scroll-top-tooltip {
    display: none; /* Ocultar tooltip en táctil / mobile */
  }
}

/* --- Auth Modal (Registro / Identificación PURI000) --- */
.ecom-auth-modal .modal-content {
  border-radius: 20px;
  border: 1px solid var(--ecom-border);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.ecom-segmented-control {
  display: flex;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
  margin-bottom: 20px;
  width: 100%;
}

.ecom-segment-btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 9px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  white-space: nowrap;
  outline: none;
  box-shadow: none;
}

.ecom-segment-btn:hover:not(.active) {
  color: #1e293b;
  background-color: rgba(255, 255, 255, 0.6);
}

.ecom-segment-btn.active {
  background-color: #0d6efd;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.28);
}

.ecom-auth-modal .modal-dialog {
  max-width: 530px;
}

.ecom-auth-modal .input-group-text {
  border-color: #cbd5e1;
  background-color: #ffffff;
  padding: 10px 14px;
}

.ecom-auth-modal .form-control {
  border-color: #cbd5e1;
  font-size: 0.92rem;
  padding: 10px 14px;
  background-color: #ffffff;
}

.ecom-auth-modal .form-control:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.ecom-auth-modal .form-label {
  letter-spacing: 0.2px;
}

/* ==========================================================================
   BUSCADOR ADAPTATIVO EN UNIFIED HEADER
   ========================================================================== */
@media (max-width: 1649px) {
  .header-search-bar-desktop {
    display: none !important;
  }
  .header-search-btn-lupa {
    display: flex !important;
  }
}

@media (min-width: 1650px) {
  .header-search-bar-desktop {
    display: flex !important;
  }
  .header-search-btn-lupa {
    display: none !important;
  }
}

@keyframes ecomFadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ecommerce.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,8EAA8E;EAC9E,wFAAwF;EACxF,0FAA0F;EAC1F,yDAAyD;AAC3D;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,yCAAyC;EACzC,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E,6EAA6E;AAC7E;;;;;;EAME,yDAAyD;EACzD,qDAAqD;EACrD,mDAAmD;EACnD,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;;;;;;EAME,8DAA8D;EAC9D,0DAA0D;EAC1D,mDAAmD;EACnD,wBAAwB;AAC1B;;AAEA,4EAA4E;AAC5E;;;;;;;;EAQE,wDAAwD;EACxD,oDAAoD;EACpD,kDAAkD;EAClD,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,6DAA6D;EAC7D,yDAAyD;EACzD,kDAAkD;EAClD,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;;;;EAIE,8CAA8C;EAC9C,qDAAqD;EACrD,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;;;EAIE,yDAAyD;EACzD,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA,mDAAmD;AACnD;;;;;EAKE,8CAA8C;AAChD;;AAEA;;;;EAIE,mDAAmD;AACrD;;AAEA,2CAA2C;AAC3C;;;;;EAKE,yDAAyD;EACzD,mDAAmD;AACrD;;AAEA;;;;;EAKE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA,kCAAkC;AAClC;;;;;EAKE,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;;;EAGE,2DAA2D;AAC7D;;AAEA,gDAAgD;AAChD;;;;EAIE,4DAA4D;AAC9D;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA,8BAA8B;AAC9B;;;;EAIE,2DAA2D;EAC3D,kDAAkD;EAClD,2DAA2D;AAC7D;;AAEA;;;;;;;;EAQE,mDAAmD;AACrD;;AAEA;;;;;;;;EAQE,kDAAkD;AACpD;;AAEA,yBAAyB;AACzB;EACE,4DAA4D;EAC5D,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;;AAGA,sCAAsC;AACtC;EACE,uHAAuH;EACvH,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uFAAuF;EACvF,kBAAkB;AACpB;;;;;;AAMA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,gDAAgD;EAChD,wCAAwC;EACxC,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,uGAAuG;AACzG;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8EAA8E;EAC9E,qBAAqB;EACrB,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,sCAAsC;EACtC;;;;uDAIqD;EACrD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uCAAuC;EACvC,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* ==========================================================================\n   ESTILOS PARA EL MÓDULO ECOMMERCE\n   ========================================================================== */\n\n:root {\n  --ecom-primary: #0d6efd;\n  --ecom-primary-dark: #0a58ca;\n  --ecom-primary-light: #e7f1ff;\n  --ecom-primary-light-bg: #f8fafc;\n  --ecom-primary-text: #ffffff;\n  --ecom-button: #ffc107;\n  --ecom-button-dark: #e0a800;\n  --ecom-button-text: #111827;\n  --ecom-accent: #ff6b35;\n  --ecom-accent-dark: #e85924;\n  --ecom-accent-light: #fff3ed;\n  --ecom-navbar-bg: #ffffff;\n  --ecom-navbar-text: #1e293b;\n  --ecom-dark: #1e293b;\n  --ecom-text: #334155;\n  --ecom-muted: #64748b;\n  --ecom-bg: #f8fafc;\n  --ecom-card-bg: #ffffff;\n  --ecom-sidebar-bg: #ffffff;\n  --ecom-sidebar-title: #1e293b;\n  --ecom-footer-bg: #ffffff;\n  --ecom-footer-text: #64748b;\n  --ecom-footer-title: #1e293b;\n  --ecom-border: #e2e8f0;\n  --ecom-radius: 12px;\n  --ecom-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03);\n  --ecom-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.04);\n  --ecom-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.03);\n  --ecom-transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nhtml,\nbody {\n  max-width: 100%;\n  overflow-x: clip;\n}\n\n.ecommerce-container,\n.webstore-site-wrapper,\n.landing-site-wrapper,\n.site-page-container {\n  background-color: var(--ecom-bg, #f8fafc);\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: clip;\n  color: var(--ecom-text, #1e293b);\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.unified-header-wrapper {\n  position: sticky;\n  top: 0;\n  z-index: 1040 !important;\n}\n\n.dropdown-toggle-no-caret::after {\n  display: none !important;\n}\n\n/* ==========================================================================\n   SOBREESCRITURAS DE TEMA PERSONALIZADO (APLICACIÓN GLOBAL EN TODA LA WEB)\n   ========================================================================== */\n\n/* 1. Botones Primarios (Acción Principal, Filtros Activos, Confirmaciones) */\n.ecommerce-container .btn-primary,\n.webstore-site-wrapper .btn-primary,\n.landing-site-wrapper .btn-primary,\n.site-page-container .btn-primary,\n.btn-theme-primary,\n.btn-primary:not(.admin-btn):not(.btn-close) {\n  background-color: var(--ecom-primary, #0d6efd) !important;\n  border-color: var(--ecom-primary, #0d6efd) !important;\n  color: var(--ecom-primary-text, #ffffff) !important;\n  border-radius: var(--ecom-radius, 12px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.ecommerce-container .btn-primary:hover,\n.webstore-site-wrapper .btn-primary:hover,\n.landing-site-wrapper .btn-primary:hover,\n.site-page-container .btn-primary:hover,\n.btn-theme-primary:hover,\n.btn-primary:not(.admin-btn):not(.btn-close):hover {\n  background-color: var(--ecom-primary-dark, #0a58ca) !important;\n  border-color: var(--ecom-primary-dark, #0a58ca) !important;\n  color: var(--ecom-primary-text, #ffffff) !important;\n  filter: brightness(0.94);\n}\n\n/* 2. Botones de Compra, Carrito y Destacados (Color de Botón Configurado) */\n.ecommerce-container .btn-warning,\n.webstore-site-wrapper .btn-warning,\n.landing-site-wrapper .btn-warning,\n.site-page-container .btn-warning,\n.btn-theme-button,\n.ecom-cart-btn,\n.ecom-btn-buy,\n.ecom-btn-action {\n  background-color: var(--ecom-button, #ffc107) !important;\n  border-color: var(--ecom-button, #ffc107) !important;\n  color: var(--ecom-button-text, #111827) !important;\n  border-radius: var(--ecom-radius, 12px);\n  font-weight: 700;\n}\n\n.ecommerce-container .btn-warning:hover,\n.webstore-site-wrapper .btn-warning:hover,\n.landing-site-wrapper .btn-warning:hover,\n.site-page-container .btn-warning:hover,\n.btn-theme-button:hover,\n.ecom-cart-btn:hover,\n.ecom-btn-buy:hover {\n  background-color: var(--ecom-button-dark, #e0a800) !important;\n  border-color: var(--ecom-button-dark, #e0a800) !important;\n  color: var(--ecom-button-text, #111827) !important;\n  filter: brightness(0.93);\n}\n\n/* 3. Botones Outline Primarios */\n.ecommerce-container .btn-outline-primary,\n.webstore-site-wrapper .btn-outline-primary,\n.landing-site-wrapper .btn-outline-primary,\n.site-page-container .btn-outline-primary {\n  color: var(--ecom-primary, #0d6efd) !important;\n  border-color: var(--ecom-primary, #0d6efd) !important;\n  border-radius: var(--ecom-radius, 12px);\n  background-color: transparent !important;\n}\n\n.ecommerce-container .btn-outline-primary:hover,\n.webstore-site-wrapper .btn-outline-primary:hover,\n.landing-site-wrapper .btn-outline-primary:hover,\n.site-page-container .btn-outline-primary:hover {\n  background-color: var(--ecom-primary, #0d6efd) !important;\n  border-color: var(--ecom-primary, #0d6efd) !important;\n  color: var(--ecom-primary-text, #ffffff) !important;\n}\n\n/* 4. Textos, Enlaces e Íconos con Color Primario */\n.ecommerce-container .text-primary,\n.webstore-site-wrapper .text-primary,\n.landing-site-wrapper .text-primary,\n.site-page-container .text-primary,\n.text-theme-primary {\n  color: var(--ecom-primary, #0d6efd) !important;\n}\n\n.ecommerce-container a.text-primary:hover,\n.webstore-site-wrapper a.text-primary:hover,\n.landing-site-wrapper a.text-primary:hover,\n.site-page-container a.text-primary:hover {\n  color: var(--ecom-primary-dark, #0a58ca) !important;\n}\n\n/* 5. Fondos y Badges Primarios / Sutiles */\n.ecommerce-container .bg-primary,\n.webstore-site-wrapper .bg-primary,\n.landing-site-wrapper .bg-primary,\n.site-page-container .bg-primary,\n.bg-theme-primary {\n  background-color: var(--ecom-primary, #0d6efd) !important;\n  color: var(--ecom-primary-text, #ffffff) !important;\n}\n\n.ecommerce-container .bg-primary-subtle,\n.webstore-site-wrapper .bg-primary-subtle,\n.landing-site-wrapper .bg-primary-subtle,\n.site-page-container .bg-primary-subtle,\n.bg-theme-primary-subtle {\n  background-color: var(--ecom-primary-light, #e7f1ff) !important;\n  color: var(--ecom-primary, #0d6efd) !important;\n}\n\n/* 6. Badges de Acento y Ofertas */\n.ecommerce-container .ecom-cart-badge,\n.webstore-site-wrapper .ecom-cart-badge,\n.landing-site-wrapper .ecom-cart-badge,\n.badge-accent,\n.bg-accent {\n  background-color: var(--ecom-accent, #ff6b35) !important;\n  color: #ffffff !important;\n}\n\n/* 7. Barra de Navegación */\n.ecommerce-container .ecom-navbar,\n.webstore-site-wrapper .ecom-navbar,\n.landing-site-wrapper .ecom-navbar {\n  background-color: var(--ecom-navbar-bg, #ffffff) !important;\n}\n\n/* 8. Fondo de Barra Lateral / Filtros / Cards */\n.ecommerce-container .ecom-sidebar-card,\n.webstore-site-wrapper .ecom-sidebar-card,\n.landing-site-wrapper .ecom-sidebar-card,\n.card-theme {\n  background-color: var(--ecom-sidebar-bg, #ffffff) !important;\n}\n\n.ecommerce-container .ecom-sidebar-card h6,\n.webstore-site-wrapper .ecom-sidebar-card h6,\n.landing-site-wrapper .ecom-sidebar-card h6,\n.ecom-sidebar-card .text-dark {\n  color: var(--ecom-sidebar-title, #1e293b) !important;\n}\n\n/* 9. Pie de Página / Footer */\n.ecommerce-container .ecom-footer,\n.webstore-site-wrapper .ecom-footer,\n.landing-site-wrapper .ecom-footer,\n.ecom-footer {\n  background-color: var(--ecom-footer-bg, #ffffff) !important;\n  color: var(--ecom-footer-text, #64748b) !important;\n  border-color: var(--ecom-footer-border, #e2e8f0) !important;\n}\n\n.ecommerce-container .ecom-footer h6,\n.webstore-site-wrapper .ecom-footer h6,\n.landing-site-wrapper .ecom-footer h6,\n.ecom-footer h6,\n.ecom-footer .text-dark,\n.ecom-footer strong,\n.ecom-footer .fw-extrabold,\n.ecom-footer .fw-bold {\n  color: var(--ecom-footer-title, #1e293b) !important;\n}\n\n.ecommerce-container .ecom-footer p,\n.webstore-site-wrapper .ecom-footer p,\n.landing-site-wrapper .ecom-footer p,\n.ecom-footer p,\n.ecom-footer .text-muted,\n.ecom-footer .text-secondary,\n.ecom-footer span:not(.badge):not(.fs-5),\n.ecom-footer li {\n  color: var(--ecom-footer-text, #64748b) !important;\n}\n\n/* --- Demo Top Bar --- */\n.ecom-demo-bar {\n  background: linear-gradient(90deg, #1e293b 0%, #334155 100%);\n  color: #f1f5f9;\n  font-size: 0.85rem;\n  padding: 8px 16px;\n  border-bottom: 1px solid #475569;\n  z-index: 1040;\n}\n\n.ecom-demo-badge {\n  background: rgba(255, 255, 255, 0.15);\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* --- Navbar --- */\n.ecom-navbar {\n  background-color: #ffffff;\n  border-bottom: 1px solid var(--ecom-border);\n  box-shadow: var(--ecom-shadow-sm);\n  position: sticky;\n  top: 0;\n  z-index: 1030;\n  padding: 12px 0;\n}\n\n.ecom-brand {\n  font-size: 1.5rem;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  color: var(--ecom-dark);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ecom-brand .brand-badge {\n  font-size: 0.7rem;\n  background-color: var(--ecom-primary);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.ecom-search-input {\n  border-radius: 30px;\n  padding-left: 42px;\n  padding-right: 18px;\n  background-color: #f1f5f9;\n  border: 1px solid transparent;\n  transition: var(--ecom-transition);\n  font-size: 0.95rem;\n}\n\n.ecom-search-input:focus {\n  background-color: #ffffff;\n  border-color: var(--ecom-primary);\n  box-shadow: 0 0 0 4px var(--ecom-primary-light);\n}\n\n.ecom-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--ecom-muted);\n  pointer-events: none;\n  font-size: 1.1rem;\n}\n\n/* --- Navbar Action Buttons Unified Height & Styling --- */\n.ecom-navbar .btn-sm {\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.86rem;\n  line-height: 1;\n  box-sizing: border-box;\n}\n\n@media (max-width: 576px) {\n  .ecom-navbar .btn-sm {\n    height: 34px;\n    font-size: 0.82rem;\n  }\n}\n\n.ecom-cart-btn {\n  position: relative;\n  border-radius: 30px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-weight: 600;\n  transition: var(--ecom-transition);\n  flex-shrink: 0;\n}\n\n.ecom-cart-btn i {\n  font-size: 1.1rem;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 576px) {\n  .ecom-cart-btn {\n    padding: 0 11px;\n  }\n  .ecom-cart-btn i {\n    font-size: 1rem;\n  }\n}\n\n.ecom-cart-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background-color: var(--ecom-accent);\n  color: white;\n  font-size: 0.7rem;\n  font-weight: 700;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.15);\n  animation: scaleIn 0.3s ease-out;\n}\n\n@keyframes scaleIn {\n  0% { transform: scale(0); }\n  80% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n/* --- User Profile Pill (Navbar) --- */\n.ecom-user-pill {\n  height: 38px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 30px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: var(--ecom-transition);\n  cursor: pointer;\n  color: #1e293b;\n  box-sizing: border-box;\n}\n\n@media (max-width: 576px) {\n  .ecom-user-pill {\n    height: 34px;\n    padding: 0 10px;\n  }\n}\n\n.ecom-user-pill:hover,\n.ecom-user-pill:focus,\n.ecom-user-pill[aria-expanded=\"true\"] {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #0f172a;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.ecom-user-pill .user-name {\n  color: #1e293b !important;\n  font-weight: 600;\n  font-size: 0.83rem;\n  max-width: 145px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.ecom-user-pill .user-list {\n  color: var(--ecom-primary) !important;\n  font-weight: 700;\n  font-size: 0.7rem;\n  display: block;\n}\n\n.ecom-user-pill::after {\n  display: none !important;\n}\n\n\n/* --- Carrusel Superior: 100% SOLO IMÁGENES --- */\n.ecom-pure-carousel-wrapper {\n  border-radius: 16px;\n  background-color: #0b192c;\n  overflow: hidden;\n}\n\n.ecom-pure-carousel {\n  border-radius: 16px;\n}\n\n.ecom-pure-carousel-item {\n  width: 100%;\n  aspect-ratio: 1200 / 320;\n  min-height: 180px;\n  max-height: 320px;\n  background-color: #0b192c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.ecom-pure-carousel-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.4s ease;\n}\n\n.ecom-pure-carousel-item:hover .ecom-pure-carousel-img {\n  transform: scale(1.015);\n}\n\n.ecom-pure-carousel .carousel-indicators {\n  margin-bottom: 12px;\n}\n\n.ecom-pure-carousel .carousel-indicators [data-bs-target] {\n  width: 26px;\n  height: 6px;\n  border-radius: 3px;\n  background-color: rgba(255, 255, 255, 0.45);\n  border: none;\n  transition: all 0.3s ease;\n  margin: 0 3px;\n}\n\n.ecom-pure-carousel .carousel-indicators .active {\n  background-color: #ffc107;\n  width: 44px;\n}\n\n.ecom-pure-carousel .carousel-control-prev,\n.ecom-pure-carousel .carousel-control-next {\n  width: 48px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.ecom-pure-carousel:hover .carousel-control-prev,\n.ecom-pure-carousel:hover .carousel-control-next {\n  opacity: 0.9;\n}\n\n.ecom-pure-carousel .carousel-control-prev-icon,\n.ecom-pure-carousel .carousel-control-next-icon {\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 16px;\n  border-radius: 50%;\n  backdrop-filter: blur(4px);\n}\n\n\n/* --- Hero Banner Fijo Original --- */\n.ecom-hero-banner {\n  background: linear-gradient(135deg, var(--ecom-primary, #0d6efd) 0%, var(--ecom-primary-dark, #0a58ca) 100%) !important;\n  color: white;\n  border-radius: var(--ecom-radius);\n  padding: 36px 32px;\n  margin-bottom: 24px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--ecom-shadow-md);\n}\n\n.ecom-hero-banner::after {\n  content: \"\";\n  position: absolute;\n  right: -40px;\n  top: -40px;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%);\n  border-radius: 50%;\n}\n\n\n\n\n\n/* --- Product Cards --- */\n.ecom-product-card {\n  background: var(--ecom-card-bg);\n  border: 1px solid var(--ecom-border);\n  border-radius: var(--ecom-radius);\n  transition: var(--ecom-transition);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--ecom-shadow-sm);\n}\n\n.ecom-product-card.ecom-product-on-sale {\n  border-color: rgba(220, 53, 69, 0.25);\n}\n\n.ecom-product-card.ecom-product-on-sale:hover {\n  border-color: rgba(220, 53, 69, 0.55);\n  box-shadow: 0 10px 25px -5px rgba(220, 53, 69, 0.12), 0 8px 10px -6px rgba(0, 0, 0, 0.05);\n}\n\n.ecom-product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--ecom-shadow-lg);\n  border-color: #cbd5e1;\n}\n\n.ecom-card-img-container {\n  height: 200px;\n  background-color: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  border-bottom: 1px solid var(--ecom-border);\n  padding: 16px;\n}\n\n.ecom-card-img {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.ecom-product-card:hover .ecom-card-img {\n  transform: scale(1.05);\n}\n\n/* --- Vista de Lista Horizontal (ecom-product-card-list) --- */\n.ecom-product-card-list {\n  display: block;\n  height: auto;\n  min-height: auto;\n}\n\n.ecom-product-card-list:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--ecom-shadow-md);\n}\n\n.ecom-card-list-img-container {\n  width: 140px;\n  height: 130px;\n  background-color: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: calc(var(--ecom-radius) - 4px);\n  border: 1px solid var(--ecom-border);\n  overflow: hidden;\n  padding: 8px;\n}\n\n.ecom-card-list-img {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.ecom-product-card-list:hover .ecom-card-list-img {\n  transform: scale(1.06);\n}\n\n.ecom-card-list-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.ecom-card-list-actions {\n  min-width: 230px;\n}\n\n@media (max-width: 767.98px) {\n  .ecom-card-list-img-container {\n    width: 100%;\n    height: 180px;\n  }\n  .ecom-card-list-actions {\n    min-width: 100%;\n  }\n}\n\n.ecom-card-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 2;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.ecom-card-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.ecom-card-brand {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--ecom-muted);\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.ecom-card-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--ecom-dark);\n  line-height: 1.35;\n  margin-bottom: 8px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.7em;\n  cursor: pointer;\n}\n\n.ecom-card-title:hover {\n  color: var(--ecom-primary);\n}\n\n.ecom-card-code {\n  font-size: 0.75rem;\n  color: var(--ecom-muted);\n  font-family: monospace;\n  margin-bottom: 10px;\n}\n\n/* --- Varieties / Colors Selector --- */\n.ecom-variants-container {\n  margin-bottom: 12px;\n}\n\n.ecom-variant-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--ecom-muted);\n  margin-bottom: 4px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ecom-variant-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ecom-variant-pill {\n  font-size: 0.75rem;\n  padding: 3px 8px;\n  border-radius: 6px;\n  border: 1px solid var(--ecom-border);\n  background-color: #f8fafc;\n  color: var(--ecom-text);\n  cursor: pointer;\n  transition: var(--ecom-transition);\n}\n\n.ecom-variant-pill:hover {\n  border-color: var(--ecom-primary);\n}\n\n.ecom-variant-pill.selected {\n  background-color: var(--ecom-primary-light);\n  border-color: var(--ecom-primary);\n  color: var(--ecom-primary-dark);\n  font-weight: 600;\n}\n\n.ecom-color-dot {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 0 1px #cbd5e1;\n  cursor: pointer;\n  transition: transform 0.15s ease;\n  display: inline-block;\n}\n\n.ecom-color-dot.selected {\n  transform: scale(1.2);\n  box-shadow: 0 0 0 2px var(--ecom-primary);\n}\n\n/* --- Price Display Area --- */\n.ecom-price-container {\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px dashed var(--ecom-border);\n  margin-bottom: 12px;\n}\n\n.ecom-price-value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: var(--ecom-dark);\n}\n\n.ecom-price-locked {\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.8rem;\n  color: var(--ecom-muted);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  cursor: pointer;\n  transition: var(--ecom-transition);\n}\n\n.ecom-price-locked:hover {\n  background-color: var(--ecom-primary-light);\n  border-color: var(--ecom-primary);\n  color: var(--ecom-primary-dark);\n}\n\n/* --- Quantity Controls --- */\n.ecom-qty-picker {\n  display: inline-flex;\n  align-items: stretch;\n  flex-shrink: 0;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n  height: 36px;\n  box-sizing: border-box;\n}\n\n.ecom-qty-picker-lg {\n  height: 44px;\n}\n\n.ecom-qty-btn {\n  background: #f8fafc;\n  border: none;\n  width: 36px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ecom-dark);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  padding: 0;\n  margin: 0;\n  flex-shrink: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n  outline: none;\n}\n\n.ecom-qty-picker-lg .ecom-qty-btn {\n  width: 44px;\n}\n\n.ecom-qty-btn:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n.ecom-qty-btn:active {\n  background: #cbd5e1;\n}\n\n.ecom-qty-input {\n  width: 44px;\n  height: 100%;\n  border: none;\n  border-left: 1px solid #e2e8f0;\n  border-right: 1px solid #e2e8f0;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.92rem;\n  color: var(--ecom-dark);\n  background: #ffffff;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.ecom-qty-picker-lg .ecom-qty-input {\n  width: 52px;\n  font-size: 1.05rem;\n}\n\n.ecom-qty-input:focus {\n  outline: none;\n  background: #ffffff;\n}\n\n/* --- Product Card Quantity Picker & Action Button --- */\n.ecom-product-card .ecom-qty-picker {\n  flex-shrink: 0;\n  height: 34px;\n}\n\n.ecom-product-card .ecom-qty-btn {\n  width: 28px;\n  font-size: 0.82rem;\n}\n\n.ecom-product-card .ecom-qty-input {\n  width: 32px;\n  font-size: 0.84rem;\n}\n\n.ecom-card-action-btn {\n  height: 34px;\n  padding: 0 10px;\n  font-size: 0.8rem;\n  white-space: nowrap;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  max-width: 140px;\n  box-sizing: border-box;\n}\n\n.ecom-card-action-btn span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecom-card-action-btn i {\n  font-size: 0.82rem;\n  flex-shrink: 0;\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .ecom-product-card .ecom-qty-picker {\n    height: 32px;\n  }\n  .ecom-product-card .ecom-qty-btn {\n    width: 25px;\n  }\n  .ecom-product-card .ecom-qty-input {\n    width: 28px;\n    font-size: 0.8rem;\n  }\n  .ecom-card-action-btn {\n    height: 32px;\n    padding: 0 5px;\n    font-size: 0.73rem;\n    gap: 2px;\n  }\n  .ecom-card-action-btn i {\n    font-size: 0.74rem;\n  }\n}\n\n/* --- Custom Modal & Drawer Close Buttons --- */\n.ecom-modal-close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  max-width: 36px;\n  max-height: 36px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 30;\n  transition: all 0.2s ease;\n  padding: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  font-size: 1rem;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.ecom-modal-close-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n  border-color: #cbd5e1;\n  transform: scale(1.08);\n}\n\n/* --- Detalle de Producto: Zoom interactivo (Lupa) y Lightbox --- */\n.ecom-detail-img-wrapper {\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n  background-color: #f8fafc;\n}\n\n.ecom-detail-img-wrapper:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.ecom-lightbox-modal .modal-content {\n  background: rgba(15, 23, 42, 0.96) !important;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n.ecom-lightbox-modal .modal-dialog {\n  margin: 0;\n  max-width: 100vw;\n  height: 100vh;\n}\n\n\n.ecom-drawer-close-btn {\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  min-height: 34px;\n  max-width: 34px;\n  max-height: 34px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  padding: 0;\n  transition: all 0.15s ease;\n  font-size: 0.95rem;\n  box-sizing: border-box;\n}\n\n.ecom-drawer-close-btn:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n  border-color: #cbd5e1;\n}\n\n/* --- Cart Drawer (Offcanvas) --- */\n.ecom-cart-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  max-width: 440px;\n  height: 100vh;\n  background: #ffffff;\n  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);\n  z-index: 1060;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ecom-cart-drawer.open {\n  transform: translateX(0);\n}\n\n.ecom-cart-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 1050;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.ecom-cart-backdrop.open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.ecom-cart-header {\n  padding: 18px 24px;\n  border-bottom: 1px solid var(--ecom-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #ffffff;\n}\n\n.ecom-cart-body {\n  padding: 16px 24px;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.ecom-cart-item {\n  display: flex;\n  gap: 14px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--ecom-border);\n}\n\n.ecom-cart-item:last-child {\n  border-bottom: none;\n}\n\n.ecom-cart-item-img {\n  width: 64px;\n  height: 64px;\n  border-radius: 8px;\n  background: #f8fafc;\n  object-fit: contain;\n  padding: 6px;\n  border: 1px solid var(--ecom-border);\n  flex-shrink: 0;\n}\n\n.ecom-cart-item-details {\n  flex-grow: 1;\n  min-width: 0;\n}\n\n.ecom-cart-item-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--ecom-dark);\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecom-cart-item-variant {\n  font-size: 0.75rem;\n  color: var(--ecom-muted);\n  margin-bottom: 6px;\n}\n\n.ecom-cart-item-price {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ecom-dark);\n}\n\n.ecom-cart-footer {\n  padding: 20px 24px;\n  border-top: 1px solid var(--ecom-border);\n  background: #f8fafc;\n}\n\n/* --- Footer --- */\n.ecom-footer {\n  margin-top: auto;\n  background-color: var(--ecom-footer-bg, #ffffff);\n  border-top: 1px solid var(--ecom-border);\n  padding: 32px 0 20px;\n  color: var(--ecom-footer-text, #64748b);\n  font-size: 0.85rem;\n}\n\n/* --- Responsive Adjustments --- */\n@media (max-width: 768px) {\n  .ecom-hero-banner {\n    padding: 24px 20px;\n  }\n  .ecom-cart-drawer {\n    max-width: 100%;\n  }\n}\n\n/* --- Filter Lists (Sidebar) --- */\n.ecom-filter-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  max-height: 260px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 4px;\n}\n\n.ecom-filter-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.ecom-filter-list::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.ecom-filter-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.ecom-filter-list::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.ecom-filter-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 34px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #475569;\n  font-size: 0.84rem;\n  font-weight: 500;\n  line-height: 1.3;\n  text-align: left;\n  flex-shrink: 0;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.ecom-filter-item:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.ecom-filter-item.active {\n  background-color: #e0edff;\n  color: #0d6efd;\n  font-weight: 700;\n  border-color: #bfdbfe;\n}\n\n.ecom-filter-item .item-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 8px;\n}\n\n/* --- Presentation Filter Pills --- */\n.ecom-presentation-group {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  background: #f1f5f9;\n  padding: 3px;\n  border-radius: 10px;\n  gap: 2px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ecom-presentation-btn {\n  width: 100%;\n  min-width: 0;\n  padding: 6px 3px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  border-radius: 8px;\n  transition: all 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  box-sizing: border-box;\n}\n\n.ecom-presentation-btn i {\n  font-size: 0.72rem;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.ecom-presentation-btn span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecom-presentation-btn.active {\n  background: #ffffff;\n  color: #0d6efd;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .ecom-presentation-btn {\n    padding: 5px 2px;\n    font-size: 0.71rem;\n    gap: 2px;\n  }\n  .ecom-presentation-btn i {\n    font-size: 0.68rem;\n  }\n}\n\n/* --- Color Filter Swatches --- */\n.ecom-color-swatches {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ecom-color-swatch-item {\n  width: 26px;\n  height: 26px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 0 1px #cbd5e1;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.ecom-color-swatch-item:hover {\n  transform: scale(1.15);\n  box-shadow: 0 0 0 2px #94a3b8;\n}\n\n.ecom-color-swatch-item.selected {\n  transform: scale(1.2);\n  box-shadow: 0 0 0 2px #0d6efd;\n}\n\n.ecom-color-swatch-rainbow {\n  background: linear-gradient(135deg, #ef4444, #eab308, #10b981, #3b82f6, #8b5cf6) !important;\n}\n\n.ecom-color-swatch-trans {\n  background: repeating-linear-gradient(45deg, #f8fafc, #f8fafc 4px, #cbd5e1 4px, #cbd5e1 8px) !important;\n}\n\n/* --- Variant Selector on Product Card --- */\n.ecom-variants-container {\n  margin-bottom: 12px;\n}\n\n.ecom-variant-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.ecom-variant-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.ecom-color-dot {\n  width: 18px;\n  height: 18px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  display: inline-block;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 0 0 1px #cbd5e1;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.ecom-color-dot:hover {\n  transform: scale(1.18);\n}\n\n.ecom-color-dot.selected {\n  transform: scale(1.28);\n  box-shadow: 0 0 0 2px #0d6efd;\n}\n\n.ecom-variant-pill {\n  font-size: 0.72rem;\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.ecom-variant-pill:hover {\n  background: #e2e8f0;\n  color: #0f172a;\n}\n\n/* --- Detail Modal Variant Selector --- */\n.ecom-detail-color-swatch {\n  width: 34px;\n  height: 34px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  transition: all 0.15s ease;\n}\n\n.ecom-detail-color-swatch:hover {\n  border-color: #cbd5e1;\n  transform: scale(1.06);\n}\n\n.ecom-detail-color-swatch.selected {\n  border-color: var(--ecom-primary, #0d6efd);\n  box-shadow: 0 0 0 1px var(--ecom-primary, #0d6efd);\n}\n\n.ecom-detail-color-swatch-dot {\n  width: 22px;\n  height: 22px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  display: block;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.ecom-variant-pill.selected {\n  background: #e0edff;\n  border-color: #93c5fd;\n  color: #0d6efd;\n  font-weight: 600;\n}\n\n/* --- Mobile Filter Drawer (Slide-over) --- */\n.ecom-filter-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  max-width: 360px;\n  height: 100vh;\n  background: #ffffff;\n  box-shadow: 4px 0 25px rgba(0, 0, 0, 0.15);\n  z-index: 1060;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(-100%);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ecom-filter-drawer.open {\n  transform: translateX(0);\n}\n\n.ecom-filter-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 1050;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.ecom-filter-backdrop.open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.ecom-filter-drawer-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--ecom-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #ffffff;\n}\n\n.ecom-filter-drawer-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.ecom-filter-drawer-body .ecom-sidebar-card {\n  box-shadow: none !important;\n  border: none !important;\n  padding: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.ecom-filter-drawer-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--ecom-border);\n  background: #ffffff;\n}\n\n/* --- Discreet Collapse Button for Desktop Sidebar --- */\n.ecom-collapse-trigger-btn {\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  min-height: 28px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.ecom-collapse-trigger-btn:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n  border-color: #cbd5e1;\n  transform: scale(1.1);\n}\n\n/* --- Floating WhatsApp Shortcut Button --- */\n.ecom-whatsapp-float-wrapper {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  z-index: 1025;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  animation: slideUpFade 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  max-width: calc(100vw - 32px);\n}\n\n@keyframes slideUpFade {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.ecom-whatsapp-btn {\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 14px rgba(37, 211, 102, 0.45), 0 2px 6px rgba(0, 0, 0, 0.15);\n  text-decoration: none;\n  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.ecom-whatsapp-btn:hover {\n  color: #ffffff;\n  transform: scale(1.08) rotate(3deg);\n  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6), 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.ecom-whatsapp-btn:active {\n  transform: scale(0.95);\n}\n\n.ecom-whatsapp-btn i {\n  font-size: 1.95rem;\n  line-height: 1;\n}\n\n/* Tooltip / Pill text */\n.ecom-whatsapp-pill {\n  background: #ffffff;\n  color: #1e293b;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 8px 14px;\n  border-radius: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  max-width: calc(100vw - 120px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ecom-whatsapp-pill:hover {\n  background: #f8fafc;\n  border-color: #25D366;\n}\n\n/* Close 'X' button */\n.ecom-whatsapp-close {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #334155;\n  color: #ffffff;\n  border: 2px solid #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  z-index: 2;\n}\n\n.ecom-whatsapp-close:hover {\n  background: #ef4444;\n  transform: scale(1.15);\n}\n\n/* Pulse animation */\n.ecom-whatsapp-pulse {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: #25D366;\n  opacity: 0.6;\n  animation: waPulse 2.2s infinite;\n  z-index: -1;\n}\n\n@keyframes waPulse {\n  0% {\n    transform: scale(0.95);\n    opacity: 0.7;\n  }\n  70% {\n    transform: scale(1.4);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1.4);\n    opacity: 0;\n  }\n}\n\n/* --- Floating Scroll to Top Button --- */\n.ecom-scroll-top-wrapper {\n  position: fixed;\n  bottom: 92px;\n  right: 31px;\n  z-index: 1024;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(14px) scale(0.9);\n  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n              visibility 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n              transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n              bottom 0.35s cubic-bezier(0.16, 1, 0.3, 1),\n              right 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n  pointer-events: none;\n}\n\n.ecom-scroll-top-wrapper.visible {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n/* Reposicionamiento fluido cuando WhatsApp se encuentra cerrado */\n.ecom-scroll-top-wrapper.no-whatsapp {\n  bottom: 24px;\n  right: 24px;\n}\n\n.ecom-scroll-top-btn {\n  position: relative;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: #0f172a;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.28), 0 2px 6px rgba(0, 0, 0, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  padding: 0;\n}\n\n.ecom-scroll-top-btn i {\n  font-size: 1.25rem;\n  line-height: 1;\n  font-weight: 700;\n  transition: transform 0.2s ease;\n}\n\n/* Tooltip on hover */\n.ecom-scroll-top-tooltip {\n  position: absolute;\n  right: calc(100% + 12px);\n  top: 50%;\n  transform: translateY(-50%) translateX(6px);\n  background: #0f172a;\n  color: #ffffff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 5px 11px;\n  border-radius: 6px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n}\n\n.ecom-scroll-top-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: -4px;\n  transform: translateY(-50%);\n  border-width: 4px 0 4px 4px;\n  border-style: solid;\n  border-color: transparent transparent transparent #0f172a;\n}\n\n.ecom-scroll-top-btn:hover {\n  background: #0d6efd;\n  color: #ffffff;\n  border-color: #0d6efd;\n  transform: translateY(-3px) scale(1.06);\n  box-shadow: 0 8px 22px rgba(13, 110, 253, 0.4), 0 3px 8px rgba(0, 0, 0, 0.15);\n}\n\n.ecom-scroll-top-btn:hover i {\n  transform: translateY(-2px);\n}\n\n.ecom-scroll-top-btn:hover .ecom-scroll-top-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(-50%) translateX(0);\n}\n\n.ecom-scroll-top-btn:active {\n  transform: translateY(0) scale(0.95);\n}\n\n@media (max-width: 576px) {\n  .ecom-whatsapp-float-wrapper {\n    bottom: 18px;\n    right: 18px;\n  }\n  .ecom-whatsapp-btn {\n    width: 52px;\n    height: 52px;\n  }\n  .ecom-whatsapp-btn i {\n    font-size: 1.7rem;\n  }\n  .ecom-scroll-top-wrapper {\n    bottom: 78px;\n    right: 24px;\n  }\n  .ecom-scroll-top-wrapper.no-whatsapp {\n    bottom: 18px;\n    right: 18px;\n  }\n  .ecom-scroll-top-btn {\n    width: 42px;\n    height: 42px;\n  }\n  .ecom-scroll-top-btn i {\n    font-size: 1.15rem;\n  }\n  .ecom-scroll-top-tooltip {\n    display: none; /* Ocultar tooltip en táctil / mobile */\n  }\n}\n\n/* --- Auth Modal (Registro / Identificación PURI000) --- */\n.ecom-auth-modal .modal-content {\n  border-radius: 20px;\n  border: 1px solid var(--ecom-border);\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n}\n\n.ecom-segmented-control {\n  display: flex;\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 4px;\n  gap: 4px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.ecom-segment-btn {\n  flex: 1 1 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 9px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  white-space: nowrap;\n  outline: none;\n  box-shadow: none;\n}\n\n.ecom-segment-btn:hover:not(.active) {\n  color: #1e293b;\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.ecom-segment-btn.active {\n  background-color: #0d6efd;\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.28);\n}\n\n.ecom-auth-modal .modal-dialog {\n  max-width: 530px;\n}\n\n.ecom-auth-modal .input-group-text {\n  border-color: #cbd5e1;\n  background-color: #ffffff;\n  padding: 10px 14px;\n}\n\n.ecom-auth-modal .form-control {\n  border-color: #cbd5e1;\n  font-size: 0.92rem;\n  padding: 10px 14px;\n  background-color: #ffffff;\n}\n\n.ecom-auth-modal .form-control:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);\n}\n\n.ecom-auth-modal .form-label {\n  letter-spacing: 0.2px;\n}\n\n/* ==========================================================================\n   BUSCADOR ADAPTATIVO EN UNIFIED HEADER\n   ========================================================================== */\n@media (max-width: 1649px) {\n  .header-search-bar-desktop {\n    display: none !important;\n  }\n  .header-search-btn-lupa {\n    display: flex !important;\n  }\n}\n\n@media (min-width: 1650px) {\n  .header-search-bar-desktop {\n    display: flex !important;\n  }\n  .header-search-btn-lupa {\n    display: none !important;\n  }\n}\n\n@keyframes ecomFadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
